import { DOCUMENT_SCAN, HOME, KEY, UPGRADE } from "../../routes/Paths";
import { CONFIG_MASTER_ENUM, STEP_MASTER_ENUM } from "../../constants/constant";
import { timerConstantValue } from "../../constants/timers";
import {
  clearScanData,
  getManualAuthentication,
  getScanDataFromWebhostQR,
} from "../../network/apiService";
import {
  faceLivelinessCall,
  faceVerificationCall,
  resetFaceData,
} from "../../store/Checkin/faceVerificationSlice";
import { fetchStep, postAuditLog, setIsSkipped } from "../../store/stageSlice";
import {
  getParametersFromLocalStorage,
  getProfileName,
  getScanDataFullName,
  homePageHandler,
  nameValidation,
  getConfigurationCode,
} from "../../helpers/commonHelper";
import {
  getPassportScanData,
  setEmailDetails,
} from "../../store/Checkin/Scan/scanPassportSlice";
import {
  getScanBackData,
  getScanData,
  getScanDocResult,
  getScanDocumentCurrentCountOfGuest,
  getTotalScannedDocument,
  incrementScanDocumentCount,
  resetDocReponse,
  scanDocumentCountOfTheGuests,
  scanDocumentRetryFace,
  updateFaceItem,
} from "../../store/Checkin/Scan/documentScanSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import ErrorPopup from "../../components/LoaderAndNotification/ErrorPopup";
import FaceVerification from "../../components/UserVerification/FaceVerification";
import Footer from "../../components/Layout/Footer";
import HomePageCard from "../../components/Layout/Card/HomePageCard";
import KeyFooter from "../../components/Layout/KeyFooter";
import LoaderPopup from "../../components/LoaderAndNotification/LoaderPopup";
import { fetchProfileDocuments } from "../../network/apiService";
import { getModuleConfiguration } from "../../store/Checkin/moduleConfigurationSlice";
import { getProfilesListData } from "../../store/Checkin/reservationformSlice";
import { getPropertyInfo } from "../../store/Checkin/Scan/propertySlice";
import { getSelectedLanguage } from "../../store/Checkin/languageSlice";
import { getStepMaster } from "../../helpers/commonHelper";
import { getconfirmationnumberData } from "../../store/Checkin/ConfirmationNumber/confirmationNumberSlice";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import useUserActivity from "../../hooks/useUserActivity";

const FaceVerificationQrScanning = () => {
  const { t } = useTranslation();
  const { screen } = useParams();

  const selectedLanguage = useSelector(getSelectedLanguage);
  const isFaceMatchEnabled = getParametersFromLocalStorage("faceMatch");
  const totalGuestCount = parseInt(
    localStorage.getItem("totalGuestCount") || 0
  );
  const timeLimit = timerConstantValue;
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState("");
  const [successLoader, setSuccessLoader] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [timerValue, setTimerValue] = useState(timeLimit);
  const [restartTimer, setRestartTimer] = useState(false);
  const [facialRecognisationFailed, setFacialRecognisationFailed] =
    useState(false);
  const [erroModalData, setErrorModalData] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const [isReload, setReload] = useState(false);
  const token = getParametersFromLocalStorage("token");
  const userData = useSelector(getPassportScanData);
  const scanData = useSelector(getScanData);
  const scanBackData = useSelector(getScanBackData);

  const [faceImage, setFaceImage] = useState(null);

  const signedInUserName = nameValidation(
    userData?.firstName,
    userData?.lastName
  );
  const dispatch = useDispatch();
  const guestCount = useSelector(getScanDocumentCurrentCountOfGuest);
  const totalScannedCount = useSelector(getTotalScannedDocument);
  // const totalCount = parseInt(localStorage.getItem("totalCount") || 0);
  const totalCount = getParametersFromLocalStorage("totalCount");
  const childCount = parseInt(localStorage.getItem("childCount") || 0);
  const [capturedImages, setCapturedImages] = useState([]);
  const [verificationInitiated, setVerificationInitiated] = useState(false);
  const [reloadCapture, setReloadCapture] = useState(false);
  const [retryCounter, setRetryCounter] = useState(0);
  const [transactionGuid, setTransactionGuid] = useState("");
  const [startFaceMatch, setStartFaceMatch] = useState(null);
  const [userName, setUserName] = useState();
  const propertyData = useSelector(getPropertyInfo);
  const profileList = useSelector(getProfilesListData);
  const docResult = useSelector(getScanDocResult);
  const reservationData = useSelector(getconfirmationnumberData);

  const isMounted = useRef(true);
  const [documentImages, setDocumentImages] = useState();

  const stepMaster = useSelector((state) => getModuleConfiguration(state));

  const documentScanPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.SCAN_DOCUMENT_PAGE
  );
  const faceVerificationPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.FACEVERIFICATION_PAGE
  );
  const manualAuthenticationPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.MANUAL_AUTHENTICATION_PAGE
  );

  const settings = getParametersFromLocalStorage("settings");

  const manualkeypickup =
    settings
      ?.find((setting) => setting.parameterName === "ManualKeyPickup")
      ?.parameterValue?.toLowerCase() === "true" ?? true;

  const enableChildScan = settings?.find(
    (setting) =>
      setting.parameterName === "EnableChildScan" &&
      setting.parameterValue?.toLowerCase() === "true"
  );
  const [showDocumentScanPage, setDocumentScanPage] =
    useState(documentScanPage?.isEnabled ?? false);
  const [showfaceVerificationPage, setfaceVerificationPage] =
    useState(faceVerificationPage?.isEnabled ?? false);
  const [manualAuthenticationRequired, setManualAuthenticationRequired] =
    useState(manualAuthenticationPage?.isEnabled ?? false);
  const [ImageLengthCount, setImageLengthCount] = useState(1);

  const LivelinessRequired = settings?.find(
    (setting) =>
      setting.parameterName === "Liveliness" &&
      setting.parameterValue?.toLowerCase() === "true"
  );
  const stepReservationPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.HOME_PAGE
  );
  const configs = stepReservationPage?.configs;
  const adultChildCountChangeRequired =
    getConfigurationCode(
      configs,
      CONFIG_MASTER_ENUM.CHILDCOUNT_CHANGE_REQUIRED
    ) ?? false;
  // useEffect(() => {
  //   if (LivelinessRequired) {
  //     console.log("Liveliness");
  //     setImageLengthCount(5);
  //   }
  // }, []);
  const isChildOrAdult = () => {
    if (enableChildScan !== null && enableChildScan !== undefined) {
      if (adultChildCountChangeRequired) {
        // if (childCount > 0 && guestCount >= (totalCount-childCount))
        if (childCount > 0 && guestCount >= totalCount - childCount) {
          return true;
        }

        return false;
      } else {
        if (
          reservationData?.childCount > 0 &&
          guestCount >= reservationData?.adultCount
        ) {
          return true;
        }
        return false;
      }
    }

    // if (enableChildScan !== null && enableChildScan !== undefined) {
    //   if (
    //     reservationData?.childCount > 0 &&
    //     guestCount >= reservationData?.adultCount
    //   ) {
    //     return true;
    //   }
    //   return false;
    // }
  };
  useEffect(() => {
    const isChild = isChildOrAdult();
    if (isChild) {
      gotoScreen();
    }
    if (
      isFaceMatchEnabled !== true &&
      (!showfaceVerificationPage || !showDocumentScanPage)
    ) {
      console.log("skip facial page");
              setLoading(false);
              setSuccessLoader(false);
              setFacialRecognisationFailed(false);
      navigate(UPGRADE, { replace: true });
      return;
    }
    dispatch(setIsSkipped(null));
  }, []);

  useEffect(() => {
    onLoad();
    return () => {
      setLoading(false);
      isMounted.current = false; // cleanup flag
    };
  }, []);

  //KC-447 Timer need to restart when user interaction is involved
  useUserActivity(() => {
    setTimerValue(timeLimit);
  });

  const onLoad = () => {
    i18n.changeLanguage(selectedLanguage).catch((err) => {
      if (err.name !== "AbortError") {
        console.error(err);
      }
    });
    dispatch(resetFaceData());
    if (
      (scanData !== null &&
        scanData?.Portrait !== null &&
        scanData?.Portrait !== undefined &&
        scanData?.Portrait !== "") ||
      (scanBackData !== null &&
        scanBackData?.Portrait !== null &&
        scanBackData?.Portrait !== undefined &&
        scanBackData?.Portrait !== "")
    ) {
      if (
        scanData?.Portrait !== undefined &&
        scanData?.Portrait !== null &&
        scanData?.Portrait !== "" &&
        scanData?.DocumentImageSide1 !== undefined &&
        scanData?.DocumentImageSide1 !== null
      ) {
        setDocumentImages({
          DocumentBase64Image: scanData?.DocumentImageSide1,
          FaceImageBase64Image: scanData?.Portrait ?? "",
        });
        setFaceImage(null);
        setFaceImage("data:image/jpeg;base64," + scanData?.Portrait ?? "");
      }

      if (
        scanBackData?.Portrait !== undefined &&
        scanBackData?.Portrait !== null &&
        scanBackData?.Portrait !== "" &&
        scanBackData?.DocumentImageSide1 !== undefined &&
        scanBackData?.DocumentImageSide1 !== null
      ) {
        setDocumentImages({
          DocumentBase64Image: scanBackData?.DocumentImageSide1,
          FaceImageBase64Image: scanBackData?.Portrait ?? "",
        });
        setFaceImage("data:image/jpeg;base64," + scanBackData?.Portrait ?? "");
      }
      setTransactionGuid(scanData?.transactionGUID ?? "");
      // if (
      //   scanData.LastName !== undefined &&
      //   scanData.LastName !== null &&
      //   scanData.LastName !== ""
      // ) {
      //   // setUserName(
      //   //   scanData.Title === null || scanData.Title === undefined
      //   //     ? ""
      //   //     : scanData.Title + " " + scanData.GivenName
      //   // );
      //   setUserName(scanData.Title+" "+ scanData.FirstName+" "+scanData.LastName);
      // } else if (
      //   scanBackData.LastName !== undefined &&
      //   scanBackData.LastName !== null &&
      //   scanBackData.LastName !== ""
      // ) {
      //   setUserName(
      //     scanBackData.Title === null || scanBackData.Title === undefined
      //       ? ""
      //       : scanBackData.Title + " " + scanBackData.FirstName+" "+ scanBackData.LastName
      //   );
      // }
      //getFullName();
      let currentProfile = null;
      if ((profileList?.length ?? 0) > guestCount)
        currentProfile = profileList[guestCount];
      setUserName(getProfileName(scanData, scanBackData, currentProfile));
      onStartFaceMatch();
    } else if (
      faceImage === null ||
      faceImage === undefined ||
      faceImage?.FaceImageBase64Image === null ||
      faceImage?.FaceImageBase64Image === undefined ||
      faceImage?.FaceImageBase64Image === ""
    ) {
      (async () => {
        if (isMounted.current)
        await getDocumentImage();
      })();
    }
  };

  const onStartFaceMatch = () => {
    resetCounter();
    setStartFaceMatch(true);
    setFacialRecognisationFailed(false);
    setReload(false);
    setLoading(false);
  };

  useEffect(() => {
    if (docResult === true) {
      dispatch(resetDocReponse());
      verifyStageInface();
      //setFacialRecognisationFailed(true);
    }
  }, [docResult, showfaceVerificationPage]);

  const getDocumentImage = async () => {
    try {
      ;
      setLoading(true);
      setLoadingMsg((prevState) => "Please wait while we process your request");
      await fetchProfileDocuments(
        {
          ConfirmationNo: userData?.pmsConfirmationNo,
          type: "CHECKIN",
        },
        token
      ).then((docresponse) => {
        if (docresponse.status === 200 && docresponse.data != null && isMounted.current) {
          let currentProfile = null;
          if ((profileList?.length ?? 0) > guestCount)
            currentProfile = profileList[guestCount];

          let guid = "";
          if (
            Array.isArray(docresponse.data.data) &&
            docresponse.data.data.length > 0
          ) {
            guid = docresponse.data.data?.find(
              (ele) =>
                ele?.PMSProfileID === currentProfile?.pmsProfileID &&
                ele?.TransactionGUID !== ""
            )?.TransactionGUID;
          } else {
            // Check if face verification is enabled in key pickup and manual key pickup is required
            const keyFaceVerification =
              localStorage.getItem("keyFaceVerification") === "true";
            //if guest checkedin at the front desk and uses kiosk for picking key, set maunualkeypickup as true to avoid errors related to missing doc image, face image etc
            if (manualkeypickup && keyFaceVerification) {
              console.log(
                "manualkeypickup is true and keyFaceVerification is true"
              );
              ;
              //setFacialRecognisationFailed(false);
              setLoading(false);
              setSuccessLoader(false);
              setFacialRecognisationFailed(false);
              //setManualAuthenticationRequired(true);
              //setShowModal(true);
              setfaceVerificationPage(true);

              setUserName(getProfileName(null, null, currentProfile));
              setDocumentImages({
                DocumentBase64Image: "",
                FaceImageBase64Image: "",
              });

              setFaceImage("data:image/jpeg;base64,");
              restartCapture();
              onStartFaceMatch();

              return;
            }

            const firstElement = docresponse.data.data[0];
            if (firstElement) {
              guid = (
                firstElement.PMSProfileID === currentProfile?.pmsProfileID &&
                firstElement?.TransactionGUID !== ""
                  ? firstElement
                  : null
              )?.TransactionGUID;
            }
          }

          if (!guid) {
            setTimeout(() => {
              console.log(
                "I got navigated back to document scan page because guid is not present",
                guid,
                docresponse,
                scanData,
                scanBackData
              );
              navigate(DOCUMENT_SCAN, { replace: true });
            }, 1500);
          }

          setTransactionGuid((prevState) => guid);

          dispatch(
            setEmailDetails({
              mail: docresponse.data?.profiles?.email,
              phone: docresponse.data?.profiles?.phoneNo_UAE,
            })
          );

          //let docImage = null;
          // if (
          //   Array.isArray(docresponse.data.data) &&
          //   docresponse.data.data?.length > 0
          // ) {
          //   const firstElement = docresponse.data.data[0];
          //   if (firstElement) {
          //     docImage =
          //       firstElement.PMSProfileID === currentProfile?.pmsProfileID
          //         ? firstElement
          //         : null;
          //   }
          // } else {
          //   docImage = docresponse.data.data?.find(
          //     (ele) => ele?.PMSProfileID === currentProfile?.pmsProfileID
          //   );
          // }

          // setDocumentImages(docImage);
          //uniqueValues.push(docImage.DocumentBase64Image);
          let faceImg = "";
          if (
            Array.isArray(docresponse.data.data) &&
            docresponse.data.data.length > 0
          ) {
            faceImg = docresponse.data.data?.find(
              (ele) =>
                ele?.PMSProfileID === currentProfile?.pmsProfileID &&
                ele?.FaceImageBase64Image !== ""
            );
          } else {
            const firstElement = docresponse.data.data[0];
            if (firstElement) {
              faceImg =
                firstElement.PMSProfileID === currentProfile?.pmsProfileID &&
                firstElement?.FaceImageBase64Image !== ""
                  ? firstElement
                  : null;
            }
          }

          if (
            faceImg?.FaceImageBase64Image !== null &&
            faceImg?.FaceImageBase64Image !== "" &&
            faceImg?.FaceImageBase64Image !== undefined
          ) {
            setFaceImage(
              "data:image/jpeg;base64," + faceImg?.FaceImageBase64Image
            );
            // const title =
            //   docImage?.Title === null || docImage?.Title === undefined
            //     ? ""
            //     : docImage?.Title + " ";
            // const username =
            //   title + "" + docImage?.FirstName + " " + docImage?.LastName;
            //
            // setUserName(username);
            setUserName(getProfileName(null, null, currentProfile));
            setDocumentImages({
              DocumentBase64Image: "",
              FaceImageBase64Image: faceImg?.FaceImageBase64Image ?? "",
            });
            dispatch(incrementScanDocumentCount());
            restartCapture();
            onStartFaceMatch();
          } else {
            console.error("Error fetching document image:");
            setLoadingMsg(
              (prevState) => "Please wait while we process your request"
            );
            setLoading(false);
            setFacialRecognisationFailed(false);
            setErrorModalData((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t(
                "Error in fetching document.Please contact front desk."
              ),
            }));
            setTimeout(() => {
              handlebackPage();
            }, 4000);
          }
        }
      });
    } catch (error) {
      console.error("Error fetching document image:", error);
      // Handle error
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: t(
          "Error in fetching document.Please contact front desk."
        ),
      }));
      setLoadingMsg((prevState) => "Please wait while we process your request");
      setSuccessLoader(false);
      setLoading(false);
      setTimeout(() => {
        handlebackPage();
      }, 4000);
    }
  };

  useEffect(() => {
    resetCounter();
    const timeout = setTimeout(() => {
      // setCaptureImages(true);
    }, 6000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (retryCounter > 0 && showfaceVerificationPage) {
      setReloadCapture(true); // Trigger reload after state reset
    }
  }, [retryCounter, showfaceVerificationPage]);

  const updateCounter = () => setRetryCounter(retryCounter + 1);
  const resetCounter = () => setRetryCounter(0);

  const handleRetry = () => {
    setReloadCapture(false); // Toggle reload state
    updateCounter();
    setCapturedImages([]);
    setReload(true);
    if (retryCounter < 3) {
      setVerificationInitiated(false);
      dispatch(scanDocumentRetryFace(1));
      setFacialRecognisationFailed(false);
      restartCapture();
      setCapturedImages([]);
    } else {
      setFacialRecognisationFailed(false);
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: t(
          "Face verification failed. Please visit front desk for assistance."
        ),
      }));
      gotoHome();
    }
  };

  const gotoHome = () => {
    resetCounter();
    const timeoutId = setTimeout(() => {
      setFacialRecognisationFailed(false);
      setCapturedImages([]);
      setStartFaceMatch(false);

      handlebackPage();
    }, 3000);
    dispatch(resetFaceData());

    return () => clearTimeout(timeoutId);
  };

  useEffect(async () => {
    if (
      capturedImages.length === ImageLengthCount &&
      startFaceMatch === true &&
      (showfaceVerificationPage ||
        (isFaceMatchEnabled !== undefined && isFaceMatchEnabled !== null))
    ) {
      const confirmationNo = localStorage.getItem("confirmationNo");
      const params = {
        imageData: capturedImages,
        transactionGuid: transactionGuid,
        docImg: documentImages?.FaceImageBase64Image ?? "",
        token: token,
        pmsConfirmationNo: confirmationNo,
      };
      setVerificationInitiated(true);
      //await Promise.race([dispatch(faceVerificationCall(params)), wait(10000)]);

      if (LivelinessRequired) {
        await dispatch(faceLivelinessCall(params))
          .unwrap()
          .then((resp) => {
            faceLivelinessCompleted(resp);
          });
      } else {
        await dispatch(faceVerificationCall(params))
          .unwrap()
          .then((resp) => {
            faceVerificationCompleted(resp);
          });
      }

      //dispatch(faceVerificationCall(params));
    }
  }, [capturedImages, startFaceMatch, showfaceVerificationPage]);

  const enableSelfie = settings?.find(
    (setting) =>
      setting.parameterName === "EnableSelfie" &&
      setting.parameterValue?.toLowerCase() === "true"
  );
  const faceVerificationCompleted = (faceResponse) => {
    addLog(
      JSON.stringify(faceResponse),
      faceResponse?.result,
      "Face verification of " + userName
    );
    if (
      (faceResponse !== null &&
        faceResponse !== undefined &&
        showfaceVerificationPage) ||
      (isFaceMatchEnabled !== undefined && isFaceMatchEnabled !== null)
    ) {
      if (faceResponse?.result === true) {
        let currentProfile = null;
        const scannedCount = totalScannedCount;
        if (totalScannedCount <= 0) {
          if ((profileList?.length ?? 0) > guestCount)
            currentProfile = profileList[guestCount];
        } else {
          if ((profileList?.length ?? 0) > guestCount)
            currentProfile = profileList[guestCount];
        }

        //   updateFaceItem({
        //     profile: currentProfile,
        //     reservation: reservationData,
        //     scanData:
        //       scanBackData !== null &&
        //       scanBackData !== undefined &&
        //       scanBackData !== ""
        //         ? scanBackData
        //         : scanData,
        //     faceImg: capturedImages[0],
        //     indexToUpdate: totalScannedCount,
        //   })
        // );
        if (enableSelfie !== null && enableSelfie !== undefined) {
          setSuccessMessage(t("Face captured successfully"));
        } else {
          setSuccessMessage(t("Face verification completed successfully"));
        }

        setSuccessLoader(true);

        updateFaceImg(
          null,
          currentProfile,
          capturedImages[0],
          totalScannedCount
        );

        setTimeout(() => {
          setSuccessLoader(false);
          return;
        }, 3000);
      } else {
        setLoading(false);
        setSuccessLoader(false);
        if (
          enableSelfie === null ||
          enableSelfie === undefined ||
          enableSelfie?.parameterValue === "false"
        )
        if (retryCounter >= 3) {
          setErrorModalData((state) => ({
            ...state,
            toggleError: true,
            errorMessage: t(
              "Face verification failed. Please visit front desk for assistance."
            ),
          }));
          gotoHome();
        } else {
          setFacialRecognisationFailed(true);
        }
      }
    }
  };

  const faceLivelinessCompleted = async (faceLivelinessResponse) => {
    try {
      addLog(
        JSON.stringify(faceLivelinessResponse),
        faceLivelinessResponse?.result,
        "Faceliveliness of guest " + userName
      );
      if (
        faceLivelinessResponse !== null &&
        faceLivelinessResponse !== undefined
      ) {
        if (faceLivelinessResponse?.isReal === true) {
          if (capturedImages.length === ImageLengthCount) {
            const confirmationNo = localStorage.getItem("confirmationNo");
            const params = {
              imageData: capturedImages,
              transactionGuid: transactionGuid,
              docImg: documentImages?.FaceImageBase64Image ?? "",
              token: token,
              pmsConfirmationNo: confirmationNo,
            };
            setVerificationInitiated(true);

            await dispatch(faceVerificationCall(params))
              .unwrap()
              .then((resp) => {
                faceVerificationCompleted(resp);
              });
          }
        } else {
        }
      } else {
        setLoading(false);
        setSuccessLoader(false);
        setFacialRecognisationFailed(true);
      }
    } catch (error) {
      setLoading(false);
      setSuccessLoader(false);
      setFacialRecognisationFailed(true);
    }
  };

  const addLog = (response, request, message) => {
    const confirmationNo = localStorage.getItem("confirmationNo");
    const data = {
      ActionName: "Facial Verification",
      Message: message ?? "",
      ControllerName: "kiosk",
      Request: request ?? "",
      PMSConfirmationNo: confirmationNo,
      AppType: "kiosk",
      Response: response ?? "",

      PropertyCode: propertyData?.data?.propertyCode,
    };
    dispatch(postAuditLog({ data, token }));
  };

  const verifyStageInface = async () => {
    if (profileList !== null && profileList !== undefined && userData) {
      let currentProfile = null;
      if ((profileList?.length ?? 0) > guestCount)
        currentProfile = profileList[guestCount];

      await dispatch(
        fetchStep({
          confirmationNo: userData?.pmsConfirmationNo,
          propertyCode: propertyData?.data?.propertyCode,
          type: "checkin",
          token: token,
          stepCode: "SEI02",
          profile: currentProfile,
          guestCount: guestCount,
        })
      )
        .unwrap()
        .then(async (isSkipped) => {
          gotoNextScreen(isSkipped);
        });
    }
  };

  const gotoNextScreen = (isSkipped) => {
    if (screen === "pickupkey") {
      setLoading(false);
      setSuccessLoader(false);
      navigate(KEY + "/key", { replace: true });
      return;
    } else {
      const isChild = isChildOrAdult();

      if (guestCount === totalCount) {
        setTimeout(() => {
          dispatch(resetFaceData());
          setLoading(false);
          setSuccessLoader(false);
          navigate(UPGRADE, { replace: true });
          return;
        }, 3000);
      } else if (guestCount < totalCount) {
        // const isChild = isChildOrAdult();
        // if(isChild){
        //   dispatch(scanDocumentCountOfTheGuests(1));
        // }
        if (isSkipped === false) {
          setTimeout(() => {
            dispatch(resetFaceData());
            setSuccessLoader(false);
            console.log(
              "I got navigated back to document scan page because isSkipped is false and gotoNextScreen is called",
              isSkipped,
              guestCount,
              totalCount
            );
            navigate(DOCUMENT_SCAN, { replace: true });
            return;
          }, 3000);
        } else {
          if (isChild) {
            setTimeout(() => {
              dispatch(resetFaceData());
              setLoading(false);
              setSuccessLoader(false);
              navigate(UPGRADE, { replace: true });
              return;
            }, 100);
          }
          dispatch(resetFaceData());

          setFacialRecognisationFailed(false);
          setCapturedImages([]);
          dispatch(resetFaceData());
          setLoading(false);
          setSuccessLoader(false);
          onLoad();
        }
      }

      return;
    }
  };

  const gotoScreen = () => {
    if (screen === "pickupkey") {
      setLoading(false);
      setSuccessLoader(false);
      navigate(KEY + "/key", { replace: true });
      return;
    } else {
      const isChild = isChildOrAdult();
      // if (isChild && guestCount > totalCount) {
      //   dispatch(resetFaceData());
      //   setLoading(false);
      //   setSuccessLoader(false);
      //   navigate(UPGRADE, { replace: true });
      // }

      let guests = guestCount;

      if (isChild) {
        dispatch(scanDocumentCountOfTheGuests(1));
        guests = guestCount + 1;
      }

      if (guests === totalCount) {
        if (isChild) {
          setTimeout(() => {
            dispatch(resetFaceData());
            setLoading(false);
            setSuccessLoader(false);
            navigate(UPGRADE, { replace: true });
            return;
          }, 100);
        }

        dispatch(resetFaceData());
        setLoading(false);
        setSuccessLoader(false);
        navigate(UPGRADE, { replace: true });
        return;
      } else if (guests < totalCount) {
        // if(isChild){
        //   dispatch(scanDocumentCountOfTheGuests(1));
        // }

        dispatch(resetFaceData());
        setSuccessLoader(false);
        console.log(
          "I got navigated back to document scan page because guests is less than totalCount: ",
          guests,
          totalCount
        );
        navigate(DOCUMENT_SCAN, { replace: true });
        return;
      }
    }
  };
  const wait = (milliseconds) =>
    new Promise((res, rej) =>
      setTimeout(
        () => rej(),
        // new Error(`Request timed out after ${milliseconds / 1000} seconds`)
        milliseconds
      )
    );

  const restartCapture = () => {
    setCapturedImages([]); // Clear captured images
    setVerificationInitiated(false); // Reset verification flag
    setReloadCapture(false); // Toggle reload state
  };

  const manualFaceVerification = async () => {
    let credentials = [];
    setFacialRecognisationFailed(false);
    try {
      setLoading(true);
      const scanDataQR = await Promise.race([
        getScanDataFromWebhostQR({}),
        wait(30000),
      ]);
      if (scanDataQR.data != null && scanDataQR.data.BarCodeData != null) {
        if (
          scanDataQR.data.BarCodeData !== null &&
          scanDataQR.data.BarCodeData !== undefined &&
          scanDataQR.data.BarCodeData !== ""
        ) {
          credentials = scanDataQR.data.BarCodeData.split(";");
        } else {
          setFacialRecognisationFailed(true);
          return;
        }

        const confirmNo = localStorage.getItem("confirmationNo");
        const response = await getManualAuthentication(
          {
            username: credentials[0],
            password: credentials[1],
            ConfirmationNo: confirmNo,
          },
          token
        );

        if (response.data.result === true) {
          let currentProfile = null;
          if (totalScannedCount <= 0) {
            if ((profileList?.length ?? 0) > guestCount)
              currentProfile = profileList[guestCount];
          } else {
            if ((profileList?.length ?? 0) > guestCount)
              currentProfile = profileList[guestCount];
          }
          dispatch(resetDocReponse());
          updateFaceImg(
            credentials[0],
            currentProfile,
            null,
            totalScannedCount
          );
          // verifyStageInface();
        } else {
          setLoading(false);
          setErrorModalData((state) => ({
            ...state,
            toggleError: true,
            errorMessage: t("Can't authenticate this time."),
          }));
          setFacialRecognisationFailed(true);
          return;
        }
      } else {
        setLoading(false);
        setFacialRecognisationFailed(true);
        return;
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setFacialRecognisationFailed(true);
      return;
    }
  };

  const updateFaceImg = (authBy, currentProfile, img, totalScannedCount) => {
    let backdata = null;
    if (scanBackData !== null && scanBackData !== undefined) {
      backdata = { ...scanBackData };
    }

    let frontdata = { ...scanData };

    let names = scanData?.FullName?.split(" ");
    if (
      scanData?.GivenName?.split(" ").length >
        scanData?.FullName?.split(" ").length &&
      scanData?.GivenName !== frontdata.FullName
    ) {
      names = scanData?.GivenName?.split(" ");
    } else {
      names = scanData?.FullName?.split(" ");
    }
    if (scanData) {
      frontdata.FirstName =
        scanData?.GivenName || scanData?.FirstName || names[names.length - 1];
      // frontdata.MiddleName = scanData?.MiddleName || names[1];
      frontdata.LastName =
        scanData?.FamilyName || scanData?.LastName || names[0];
    }
    if (scanBackData) {
      let bnames = backdata?.FullName?.split(" ");
      if (
        backdata?.GivenName?.split(" ").length >
          backdata?.FullName?.split(" ").length &&
        backdata?.GivenName !== frontdata.FullName
      ) {
        bnames = backdata?.GivenName?.split(" ");
      } else {
        bnames = backdata?.FullName?.split(" ");
      }

      backdata.FirstName =
        frontdata.FirstName ||
        backdata.GivenName ||
        backdata.FirstName ||
        bnames[bnames.length - 1] ||
        "";

      // backdata.MiddleName = frontdata.MiddleName || backdata.MiddleName
      // || bnames[1] || "";

      backdata.LastName =
        frontdata.LastName ||
        backdata.FamilyName ||
        backdata.LastName ||
        bnames[0] ||
        "";

      frontdata.FirstName = backdata.FirstName;
      // frontdata.MiddleName = backdata.MiddleName;
      frontdata.LastName = backdata.LastName;
    }
    dispatch(
      updateFaceItem({
        profile: currentProfile,
        reservation: reservationData,
        scanData:
          backdata !== null && backdata !== undefined && backdata !== ""
            ? backdata
            : frontdata,
        faceImg: img ?? null,
        indexToUpdate: totalScannedCount,
        manualAuthby: authBy,
        transactionGuid: transactionGuid,
      })
    );
  };

  const resetTimerAndClosePopUp = () => {
    if (!timerValue) {
      setTimerValue(timeLimit);
    }
    setRestartTimer(true);
    setShowModal(false);
  };

  const timerCounter = (value) => {
    setTimerValue(value);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const stopTimer = () => {
    setRestartTimer(false);
  };

  const closeErrorModal = () => {
    setErrorModalData((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };

  // const handleImageCapture = async (capturedImage) => {
  //   try {
  //     if (capturedImages.length < 1) {
  //       setCapturedImages((prevImages) => {
  //         const updatedImages = [...prevImages, capturedImage];
  //         return updatedImages;
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error capturing image:", error);
  //   }
  // };
  const compressBase64Image = (
    base64Image,
    quality = 0.7,
    maxWidthOrHeight = 500
  ) => {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.src = base64Image;

      img.onload = () => {
        // Create a canvas to draw the image
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Get original image dimensions
        let width = img.width;
        let height = img.height;

        // Resize logic based on maxWidthOrHeight while maintaining aspect ratio
        if (width > height) {
          if (width > maxWidthOrHeight) {
            height = Math.floor((height *= maxWidthOrHeight / width));
            width = maxWidthOrHeight;
          }
        } else {
          if (height > maxWidthOrHeight) {
            width = Math.floor((width *= maxWidthOrHeight / height));
            height = maxWidthOrHeight;
          }
        }

        // Set the canvas dimensions to the new size and draw the image
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        // Convert the canvas content to a compressed base64 string
        const compressedBase64 = canvas.toDataURL("image/jpeg", quality); // Quality is between 0 and 1

        resolve(compressedBase64);
      };

      img.onerror = reject; // Handle image load errors
    });
  };

  const handleImageCapture = async (capturedImage) => {
    try {
      if (capturedImages.length < 1) {
        // Compress the base64 image using the utility function
        const compressedImage = await compressBase64Image(capturedImage);
        setCapturedImages((prevImages) => {
          const updatedImages = [...prevImages, compressedImage];
          return updatedImages;
        });
      }
    } catch (error) {
      console.error("Error capturing and compressing image:", error);
    }
  };

  const handlebackPage = () => {
    try {
      homePageHandler(dispatch, navigate);
    } catch (error) {
      console.error("Error capturing image:", error);
    }
  };

  return (
    <div>
      <ErrorPopup
        closeErrorModal={closeErrorModal}
        erroModalData={erroModalData}
      />
      {/* {userName && faceImage ? (
        <>
          <FaceVerification
            loading={loading}
            successLoader={successLoader}
            successMessage={successMessage}
            openModal={openModal}
            closeErrorModal={closeErrorModal}
            erroModalData={erroModalData}
            signedInUserName={signedInUserName}
            facialRecognisationFailed={facialRecognisationFailed}
            completedFacialRecognisation={manualFaceVerification}
            manualAuthenticationRequired={manualAuthenticationRequired}
            backToHomePage={handlebackPage}
            faceImage={faceImage}
            scanName={userName}
            guestCount={guestCount}
            retryFace={handleRetry}
            onImageCapture={handleImageCapture}
            isReload={isReload}
            enableSelfie={
              enableSelfie?.parameterValue === "true" ? true : false
            }
            loadingMsg={loadingMsg}
          />
        </>
      ) : (
        <>
          <LoaderPopup loading={true} />
        </>
      )} */}

      {userName && faceImage ? (
        <>
          <FaceVerification
            loading={loading}
            successLoader={successLoader}
            successMessage={successMessage}
            openModal={openModal}
            closeErrorModal={closeErrorModal}
            erroModalData={erroModalData}
            signedInUserName={signedInUserName}
            facialRecognisationFailed={facialRecognisationFailed}
            completedFacialRecognisation={manualFaceVerification}
            manualAuthenticationRequired={manualAuthenticationRequired}
            backToHomePage={handlebackPage}
            faceImage={faceImage}
            scanName={userName}
            guestCount={guestCount}
            retryFace={handleRetry}
            onImageCapture={handleImageCapture}
            isReload={isReload}
            enableSelfie={
              enableSelfie?.parameterValue === "true" ? true : false
            }
            loadingMsg={loadingMsg}
          />
        </>
      ) : (
        <>
          {manualkeypickup ? (
            <LoaderPopup loading={false} />
          ) : (
            <LoaderPopup loading={true} />
          )}
        </>
      )}

      {screen === "pickupkey" ? (
        <>
          <KeyFooter
            page={"face"}
            showModal={showModal}
            openModal={openModal}
            timerCounter={timerCounter}
            timerValue={timerValue}
            restartTimer={restartTimer}
            stopTimer={stopTimer}
            timeLimit={timeLimit}
            isFaceMatchEnabled={isFaceMatchEnabled}
          />
        </>
      ) : (
        <>
          <Footer
            page={"facerecognition"}
            showModal={showModal}
            openModal={openModal}
            timerCounter={timerCounter}
            timerValue={timerValue}
            restartTimer={restartTimer}
            stopTimer={stopTimer}
            timeLimit={timeLimit}
          />
        </>
      )}

      {showModal && (
        <HomePageCard
          showModal={showModal}
          resetTimerAndClosePopUp={resetTimerAndClosePopUp}
        />
      )}
    </div>
  );
};

export default FaceVerificationQrScanning;
